export default {"src":"/_next/static/media/host-light.327fd097.svg","height":256,"width":256};